import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import DeliveryTime from '@components/DeliveryTime';
import FormatPrice from '@shared/containers/FormatPrice';

import messages from './messages';
import {
  Container,
  StyledPeyaPlus,
  StyledPrice,
  FleetUtilisationIcon,
  Separator,
} from './DeliveryContainer';

const HIGH = 'HIGH';

function Delivery({
  amount = 0,
  minMinutes,
  maxMinutes,
  deliveryTime,
  isExpress,
  fleetUtilisationLevel,
  variableShippingFee,
  intl: { formatMessage },
  originalShippingAmount,
  hasLoyaltyDeliveryFee,
  pickUpDistance,
  isPickUpSelected,
  hasSurgeFee,
}) {
  const deliveryAmountMessage = formattedPrice => {
    if (variableShippingFee)
      return formatMessage(messages.deliveryAmountVariable);

    return amount === 0
      ? formatMessage(messages.deliveryAmountFree)
      : formatMessage(messages.deliveryAmount, {
          deliveryAmount: formattedPrice,
        });
  };

  return (
    <Container>
      <DeliveryTime
        deliveryTime={deliveryTime}
        minTime={minMinutes}
        maxTime={maxMinutes}
        isExpress={isExpress}
      />
      <Separator>·</Separator>
      {!!hasLoyaltyDeliveryFee && <StyledPeyaPlus />}
      {isPickUpSelected && pickUpDistance && (
        <StyledPrice>{pickUpDistance}</StyledPrice>
      )}
      {!isPickUpSelected && amount !== null && (
        <FormatPrice value={amount}>
          {formattedPrice => (
            <StyledPrice bold={!!hasLoyaltyDeliveryFee && amount === 0}>
              {deliveryAmountMessage(formattedPrice)}
            </StyledPrice>
          )}
        </FormatPrice>
      )}
      {!isPickUpSelected && originalShippingAmount !== null && (
        <FormatPrice original value={originalShippingAmount}>
          {formattedPrice =>
            !!hasLoyaltyDeliveryFee &&
            amount !== 0 && (
              <>
                <Separator width="1"></Separator>
                <StyledPrice original underlined>
                  {formatMessage(messages.deliveryOriginalAmount, {
                    deliveryAmount: formattedPrice,
                  })}
                </StyledPrice>
              </>
            )
          }
        </FormatPrice>
      )}
      {fleetUtilisationLevel === HIGH && amount > 0 && (
        <FleetUtilisationIcon size="medium" />
      )}
      {hasSurgeFee && <FleetUtilisationIcon size="medium" />}
    </Container>
  );
}

Delivery.propTypes = {
  amount: PropTypes.number.isRequired,
  isExpress: PropTypes.bool.isRequired,
  deliveryTime: PropTypes.string,
  minMinutes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxMinutes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  intl: intlShape,
  fleetUtilisationLevel: PropTypes.string,
  variableShippingFee: PropTypes.bool,
  originalShippingAmount: PropTypes.number,
  hasLoyaltyDeliveryFee: PropTypes.bool,
  pickUpDistance: PropTypes.string,
  isPickUpSelected: PropTypes.bool,
  hasSurgeFee: PropTypes.bool,
};

export default injectIntl(Delivery);
